export class BankAccountM{
  id:number = 0
  type:string = ""
  name_en:string = ""
  name_th:string = ""
  bank_en:string = ""
  bank_th:string = ""
  bank_abbrev:string = ""
  account_name_en:string = ""
  account_name_th:string = ""
  account_type_en:string = ""
  account_type_th:string = ""
  account_no:string = ""
  branch_en:string = ""
  branch_th:string = ""
  image:string = ""
  show_in_invoice:boolean = false
}



// WEBPACK FOOTER //
// ./src/app/model/bank_account.mobel.ts